import React from 'react';
import theme from '../../../theme';
import useWindowDimensions from '../../../hooks/useWindowDimensions';
import { number } from '../../../util/devices';

const ReportTitle = ({
    sharedReviewTitle,
    companyLogoUrl,
    companyName,
    style,
}: {
    sharedReviewTitle: string | undefined | null;
    companyLogoUrl: string | undefined | null;
    companyName: string | undefined | null;
    style?: React.CSSProperties;
}) => {
    const { width } = useWindowDimensions();

    return (
        <div
            style={{
                height: '50%',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'flex-start',
                fontWeight: 'bold',
                fontSize: 22,
                color: theme.colors.blue100,
                ...style,
            }}
        >
            {companyLogoUrl ? (
                <img
                    style={{
                        marginLeft: 20,
                        marginRight: 20,
                        maxHeight: width > number.MOBILE_LG ? 50 : 40,
                    }}
                    src={companyLogoUrl}
                    alt="Your Company logo"
                />
            ) : null}
            {companyName ||
                (sharedReviewTitle ?? (
                    <div
                        style={{
                            width: 160,
                            height: 24,
                            backgroundColor: theme.colors.blue10,
                            borderRadius: 8,
                        }}
                    />
                ))}
        </div>
    );
};

export default ReportTitle;
